"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeoRhythmDevice = void 0;
const events_1 = require("events");
const bluetooth_le_1 = require("@capacitor-community/bluetooth-le");
const neorhythm_mapping_1 = require("../lib/neorhythm-mapping");
const neorhythm_parsers_1 = require("../lib/neorhythm-parsers");
const c = __importStar(require("../lib/constants"));
const neorhythm_utils_1 = require("../lib/neorhythm-utils");
const rxjs_1 = require("rxjs");
const neorhythm_1 = require("../pipes/neorhythm");
class NeoRhythmDevice extends events_1.EventEmitter {
    constructor() {
        super();
        this.active = new rxjs_1.BehaviorSubject(false);
        this.sessions = [];
        // TODO: reset clock at new session
        this.clock = neorhythm_1.clock(this);
        // TODO: Fix – change clock to BehaviourSubject to read value
        // save session when stimulation stops
        this.clock.toPromise().then((v) => {
            this.sessions.push({
                start: new Date().getTime() - v * 1000,
                end: new Date().getTime(),
            });
        });
    }
    async setProgram(device, program, duration) {
        const p = neorhythm_mapping_1.standardToNeoRhythm(program);
        if (program.type === 'predefined') {
            await neorhythm_parsers_1.initPredefinedProgram(device.deviceId, { program: p.program || 0, duration });
        }
        else if (program.type === 'custom') {
            const { intensity, frequency, coil } = p;
            await neorhythm_parsers_1.initCustomProgram(device.deviceId, { intensity: intensity || 1, frequency: frequency || 1, coil: coil || 1, duration });
        }
    }
    startStimulation(device) {
        // TODO: move telemetry init
        this.telemetry = neorhythm_1.telemetry(device);
        this.program = neorhythm_1.program(device);
        // stimulation is started/stopped by hardware tap
        bluetooth_le_1.BleClient.startNotifications(device.deviceId, c.NEORHYTHM_SERVICE, c.NEORHYTHM_CHARACTERISTIC, (v) => {
            const count = neorhythm_utils_1.decodeStimulationCounter(v);
            if (count) {
                this.emit('update', count[0]);
                this.active.next(true);
            }
            const stop = neorhythm_utils_1.decodeStopStimulation(v);
            if (stop) {
                this.emit('stop');
                this.active.next(false);
            }
        });
    }
}
exports.NeoRhythmDevice = NeoRhythmDevice;
//# sourceMappingURL=neorhythm.js.map